import apiClient from '../api';

export const createOrganization = (data, header) => apiClient.post(`/organization`, data, header);

export const createOrganizationForSnapshot = (data, header) => apiClient.post(`/organization/create/snapshotvideos/org`, data, header);

export const updateOrganization = (id, data, header) => apiClient.put(`/organization/${id}`, data, header);

export const deleteOrganization = (id) => apiClient.delete(`/organization/delete/${id}`);

export const getOrganization = (data) => apiClient.get(`/organization/${data.id}`);

export const getOrganizationContacts = (data) => apiClient.get(`/organization/get/contacts/${data.id}`);

export const fetchOrganizationByName = (data) => apiClient.get(`/organization/by/name?s=${data.name}`);

export const getOrganizationList = (id) => apiClient.get(`/organization/all/${id}`);

export const getAllOrganizations = (header) => apiClient.get(`/organization/get/all`, header);

export const signupForOrganizationWithUser = (data) => apiClient.post(`/organization/signup`, data);

export const getAllTempOrganizations = (query) => apiClient.get(`/organization/get/temp/organization/list/${query}`);

export const createOrgAccountWithUser = (data) => apiClient.post(`/organization/create/user/account`, data);

export const getAllOrgWithDetail = () => apiClient.get(`/organization/get/organization/list`);

export const sendOrganizationInvite = (data, header) => apiClient.post(`/organization/invite/user`, data, header);
export const registerFromInvite = (data) => apiClient.post('/organization/register-from-invite', data);
